<template>
<div class="row page">
        <div class="form-account form-sign-in">
            <h1>Password Reset</h1>
            <p>Please enter your email address to request to reset your password</p>
            <ValidationObserver ref="resetPasswordForm">
                <form v-on:submit.prevent="requestReset()">
                    <ul>
                        <li>
                            <label for="email">Email address</label>
                            <ValidationProvider rules="required|email" v-slot="{ errors }">
                                <input id="email" type="text" v-model="email" class="form-account__email">
                                <span class="form__error" v-if="errors">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </li>
                    </ul>
                    <div v-if="infoMessage" class="infobar" v-bind:class="{'infobar-info' : !error, 'infobar-error' : error}">
                        {{infoMessage}}
                    </div>
                    <div v-show="waiting">
                        <Spinner/>
                    </div>
                    <template v-if="!waiting && !success">
                        <button class="btn btn-primary" >Request password reset</button>
                        <div class="form-account__alt-action"><router-link to="/">Sign in instead</router-link></div>
                    </template>
                </form>
            </ValidationObserver>
        </div>
    </div>
</template>

<script>
    import { ValidationObserver, ValidationProvider } from 'vee-validate'

    import Spinner from '../components/Spinner'

    export default {
        name: "ForgotPassword.vue",
        components: { ValidationObserver, ValidationProvider, Spinner },
        data: function () {
            return {
                email: "",
                waiting: false,
                success: false,
                error: false,
                infoMessage: ""
            }
        },
        computed: {
        },
        methods: {
            requestReset: function () {
                this.$refs.resetPasswordForm.validate().then(success => {
                    if (!success) {
                        return
                    }

                    this.waiting = true;
                    this.error = false;
                    this.success = false;
                    this.infoMessage = "";

                    this.$http.post('/guest-management/v1/users/forgot-password?email=' + this.email
                    ).then(() => {
                        this.success = true;
                        this.infoMessage = "An email has been sent to the above email address with instruction on " +
                            "how to set a new password. Please check your email inbox";
                        return
                    }).catch(error => {
                        this.error = true;
                        if (error.response && error.response.data.message) {
                            this.infoMessage = error.response.data.message
                        } else {
                            this.infoMessage = "Sorry, we can't seem to reach our servers! Please try again"
                        }
                    }).finally(() => {
                        this.waiting = false;
                    })
                });
            }
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../styles/pages/sign-in";
</style>